import { render, staticRenderFns } from "./RevenueShareDetailTable.vue?vue&type=template&id=79f51d66&scoped=true&"
import script from "./RevenueShareDetailTable.vue?vue&type=script&lang=js&"
export * from "./RevenueShareDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./RevenueShareDetailTable.vue?vue&type=style&index=0&id=79f51d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f51d66",
  null
  
)

export default component.exports